<template>
  <div class="page-home">
    <!--banner-->
    <div class="banner">
      <div class="container">
        <h2>游戏推荐</h2>
        <div class="banner-matter">
          <Slider/>
        </div>
      </div>
    </div>
    <!--banner end-->
    <!--content-->
    <div class="content" style="display: block;">
      <div class="container">
        <!--content-top-->
        <div class="content-top">
          <div class="col-md-9 top-col">
            <!--Left-->
            <div class="col-top">
              <div class="col-md-6 black" v-for="(n, index) in navLeftList" :key="index">
                <a v-if="n.html" :href="'static/article/'+n.path+'.html'" target="_blank">
                  <img class="img-responsive" :src="imgUrl('static/images/index/'+n.path)" alt="">
                  <div class="col">
                    <h4>{{ n.title }}</h4>
                  </div>
                </a>
                <router-link v-else :to="'/game/'+n.path" :title="n.title" target="_blank">
                  <img class="img-responsive" :src="imgUrl('static/images/index/'+n.path)" alt="">
                  <div class="col">
                    <h4>{{ n.title }}</h4>
                  </div>
                </router-link>
              </div>

              <div class="clearfix"></div>
            </div>
            <!--Text Link-->
            <div class="col-top-bottom">
              <div class="link-block">
                <LeftText/>
              </div>

              <div class="clearfix"></div>
            </div>
          </div>
          <!--Right-->
          <div class="col-md-3 per">
            <template v-for="(r, index) in navRightList">
              <a
                v-if="r.html"
                :key="'a-' + index"
                :href="'static/article/'+r.path+'.html'"
                :title="r.title"
                target="_blank">
                <el-image class="img-responsive" :src="imgUrl('static/images/index/'+r.path)" alt="">
                  <div slot="placeholder" class="img-placeholder home">
                    图片加载中<span class="dot">...</span>
                  </div>
                </el-image>
                <div class="six">
                  <h4>{{ r.title }}</h4>
                </div>
              </a>
              <router-link
                v-else
                :key="'link-' + index"
                :to="'/game/'+r.path"
                :title="r.title"
                target="_blank">
                <el-image class="img-responsive" :src="imgUrl('static/images/index/'+r.path)" alt="">
                  <div slot="placeholder" class="img-placeholder home">
                    图片加载中<span class="dot">...</span>
                  </div>
                </el-image>
                <div class="six">
                  <h4>{{ r.title }}</h4>
                </div>
              </router-link>
            </template>
          </div>

          <div class="clearfix"></div>
        </div>
      </div>
      <!--//content-top-->
      <!---->
      <div class="container">
        <div class="content-bottom">
          <!-- 最近发布 -->
          <div class="col-md-12 bottom-content no-plr">
            <h4>最近发布
              <router-link to="/game">查看更多 ></router-link>
            </h4>
            <div
                class="col-md-3 blog-top"
                v-for="(game,index) in filteredGameListNew"
                :key="index">
              <router-link :to="'/game/'+game.path" :title="game.title" target="_blank">
                <div class="blog-in">
                  <div class="face-box" :title="game.title">
                    <el-image class="img-responsive" :src="jietuUrl('static/images/game/'+game.path+'/jietu-1', game.imgExt)" :alt="game.title">
                      <div slot="placeholder" class="img-placeholder home">
                        图片加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                    <div class='MarkBox' v-if="checkDaysDifference(game.date)">
                      <div class='insideBox'>新发</div>
                    </div>
                    <div class='MarkBox' v-if="game.tuijian === 1">
                      <div class='insideBox tuijian'>推荐</div>
                    </div>
                    <div class='MarkBox' v-if="game.hot === 1">
                      <div class='insideBox hot'>热门</div>
                    </div>
                    <div class='MarkBox' v-if="game.biwan === 1">
                      <div class='insideBox biwan'>必玩</div>
                    </div>
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <div v-if="game.enTitle">（{{ game.enTitle }}）</div>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="clearfix"></div>
          <!-- 最近更新 -->
          <div class="col-md-12 bottom-content no-plr">
            <h4>最近版本更新
              <router-link to="/game">查看更多 ></router-link>
            </h4>
            <div
class="col-md-3 blog-top"
v-for="(game,index) in filteredGameListRecent"
                 :key="index">
              <router-link :to="'/game/'+game.path" :title="game.title" target="_blank">
                <div class="blog-in">
                  <div class="face-box" :title="game.title">
                    <el-image class="img-responsive" :src="jietuUrl('static/images/game/'+game.path+'/jietu-1', game.imgExt)" :alt="game.title">
                      <div slot="placeholder" class="img-placeholder home">
                        图片加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                    <div class='MarkBox' v-if="checkDaysDifference(game.update)">
                      <div class='insideBox update'>更新</div>
                    </div>
                    <div class='MarkBox' v-if="game.tuijian === 1">
                      <div class='insideBox tuijian'>推荐</div>
                    </div>
                    <div class='MarkBox' v-if="game.hot === 1">
                      <div class='insideBox hot'>热门</div>
                    </div>
                    <div class='MarkBox' v-if="game.biwan === 1">
                      <div class='insideBox biwan'>必玩</div>
                    </div>
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <div v-if="game.enTitle">（{{ game.enTitle }}）</div>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="clearfix"></div>
          <!-- 必玩 -->
          <div class="col-md-12 bottom-content no-plr">
            <h4>必玩游戏
              <router-link to="/game">查看更多 ></router-link>
            </h4>
            <div
class="col-md-3 blog-top"
v-for="(game,index) in filteredGameList4"
                 :key="index">
              <router-link :to="'/game/'+game.path" :title="game.title" target="_blank">
                <div class="blog-in">
                  <div class="face-box" :title="game.title">
                    <el-image class="img-responsive" :src="jietuUrl('static/images/game/'+game.path+'/jietu-1', game.imgExt)" :alt="game.title">
                      <div slot="placeholder" class="img-placeholder home">
                        图片加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                    <div class='MarkBox' v-if="game.tuijian === 1">
                      <div class='insideBox tuijian'>推荐</div>
                    </div>
                    <div class='MarkBox' v-if="game.hot === 1">
                      <div class='insideBox hot'>热门</div>
                    </div>
                    <div class='MarkBox' v-if="game.biwan === 1">
                      <div class='insideBox biwan'>必玩</div>
                    </div>
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <div v-if="game.enTitle">（{{ game.enTitle }}）</div>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="clearfix"></div>
          <!-- 已汉化 -->
          <div class="col-md-12 bottom-content no-plr">
            <h4>已汉化游戏
              <router-link to="/game">查看更多 ></router-link>
            </h4>
            <div
class="col-md-3 blog-top"
v-for="(game,index) in filteredGameList"
                 :key="index">
              <router-link v-if="!game.flash" :to="'/game/'+game.path" :title="game.title" target="_blank">
                <div class="blog-in">
                  <div class="face-box" :title="game.title">
                    <el-image class="img-responsive" :src="jietuUrl('static/images/game/'+game.path+'/jietu-1', game.imgExt)" :alt="game.title">
                      <div slot="placeholder" class="img-placeholder home">
                        图片加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                    <div class='MarkBox' v-if="game.tuijian === 1">
                      <div class='insideBox tuijian'>推荐</div>
                    </div>
                    <div class='MarkBox' v-if="game.hot === 1">
                      <div class='insideBox hot'>热门</div>
                    </div>
                    <div class='MarkBox' v-if="game.biwan === 1">
                      <div class='insideBox biwan'>必玩</div>
                    </div>
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <div v-if="game.enTitle">（{{ game.enTitle }}）</div>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="clearfix"></div>
          <!-- 汉化中 -->
          <div class="col-md-12 bottom-content no-plr">
            <h4>汉化中游戏
              <router-link to="/game">查看更多 ></router-link>
            </h4>
            <div
class="col-md-3 blog-top"
v-for="(game,index) in filteredGameList2"
                 :key="index">
              <router-link v-if="!game.flash" :to="'/game/'+game.path" :title="game.title" target="_blank">
                <div class="blog-in">
                  <div class="face-box" :title="game.title">
                    <el-image class="img-responsive" :src="jietuUrl('static/images/game/'+game.path+'/jietu-1', game.imgExt)" :alt="game.title">
                      <div slot="placeholder" class="img-placeholder home">
                        图片加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                    <div class='MarkBox' v-if="game.tuijian === 1">
                      <div class='insideBox tuijian'>推荐</div>
                    </div>
                    <div class='MarkBox' v-if="game.hot === 1">
                      <div class='insideBox hot'>热门</div>
                    </div>
                    <div class='MarkBox' v-if="game.biwan === 1">
                      <div class='insideBox biwan'>必玩</div>
                    </div>
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <div v-if="game.enTitle">（{{ game.enTitle }}）</div>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="clearfix"></div>
          <!--  其它游戏-->
          <div class="col-md-12 bottom-content no-plr">
            <h4>其它游戏
              <router-link to="/game">查看更多 ></router-link>
            </h4>
            <div
class="col-md-3 blog-top"
v-for="(game,index) in filteredGameList3"
                 :key="index">
              <router-link v-if="!game.flash" :to="'/game/'+game.path" :title="game.title" target="_blank">
                <div class="blog-in">
                  <div class="face-box" :title="game.title">
                    <el-image class="img-responsive" :src="jietuUrl('static/images/game/'+game.path+'/jietu-1', game.imgExt)" :alt="game.title">
                      <div slot="placeholder" class="img-placeholder home">
                        图片加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                    <div class='MarkBox' v-if="checkDaysDifference(game.update)">
                      <div class='insideBox update'>更新</div>
                    </div>
                    <div class='MarkBox' v-if="game.tuijian === 1">
                      <div class='insideBox tuijian'>推荐</div>
                    </div>
                    <div class='MarkBox' v-if="game.hot === 1">
                      <div class='insideBox hot'>热门</div>
                    </div>
                    <div class='MarkBox' v-if="game.biwan === 1">
                      <div class='insideBox biwan'>必玩</div>
                    </div>
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <div v-if="game.enTitle">（{{ game.enTitle }}）</div>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </router-link>
              <a v-if="game.flash" :href="'static/flash/'+game.path+'.html'" :title="game.title" target="_blank">
                <div class="blog-in">
                  <div class="face-box" :style="'background: url('+jietuUrl('static/images/game/'+game.path+'/jietu-1', game.imgExt)+') no-repeat;'" :title="game.title">
<!--                    <img class="img-responsive" :src="'static/images/game/'+game.path+'/jietu-1.png'" :alt="game.title">-->
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <div>（{{ game.enTitle }}）</div>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>

    </div>
    <!--content-->
  </div>
</template>

<script>
import LeftText from '@/components/Home/Left_Text.vue'
import Slider from '@/components/Home/Slider.vue'
import imageExt from '@/mixins/imageExt'

export default {
  name: 'Index',
  mixins: [imageExt],
  components: {
    LeftText,
    Slider
  },
  data() {
    return {
      showNumber: 8,
      showNumberOther: 12,
      typeList: [],
      navLeftList: [],
      navRightList: [],
      gameList: [],
      gameList2: [],
      gameList3: [],
      gameList4: [],
      gameListRecent: [],
      gameListNew: [],
      gameListOther: [],
      curType: '已汉化',
      curType3: '必玩',
      curType2: '汉化中'
    }
  },
  created() {
    this.getSetting()
    // this.getData()
    this.getNavData()
  },
  computed: {
    filteredGameListNew() {
      return this.gameListNew.slice(0, this.showNumber)
    },
    filteredGameListRecent() {
      return this.gameListRecent.slice(0, this.showNumber)
    },
    filteredGameList() {
      return this.gameList.slice(0, this.showNumber)
    },
    filteredGameList2() {
      return this.gameList2.slice(0, this.showNumber)
    },
    filteredGameList3() {
      return this.gameList3.slice(0, this.showNumberOther)
    },
    filteredGameList4() {
      return this.gameList4.slice(0, this.showNumber)
    }
  },
  methods: {
    getSetting() {
      const timeStamp = new Date().getTime()
      // 获取网站配置，存入本地储存
      this.$http.get('static/data/setting.json' + '?' + timeStamp).then(game => {
        // 如果本地有记录，对比配置版本号是否一致
        if(localStorage.getItem('settingList') && (game.data[0].version === JSON.parse(localStorage.getItem('settingList'))[0].version)){
          // 读取本地json
          this.getStaticData()
        } else {
          // 覆盖本地版本号
          localStorage.setItem('settingList', JSON.stringify(game.data))
          // 读取远程json
          this.getData()
        }
      })
    },
    getData() {
      const timeStamp = new Date().getTime()
      this.$http.get('static/data/games.json' + '?' + timeStamp).then(game => {
        // 存储游戏json到本地存储
        localStorage.setItem('gameList', JSON.stringify(game.data))
        const activeGames = game.data.filter(g => g.status !== 0)
        this.gameList = activeGames.filter(g => g.type.includes(this.curType))
        this.gameList2 = activeGames.filter(g => g.type.includes(this.curType2) && !g.type.includes(this.curType)).sort((a, b) => Date.parse(b.update) - Date.parse(a.update))
        this.gameList3 = activeGames.filter(g => !g.type.includes(this.curType) && !g.type.includes(this.curType2) && !g.type.includes(this.curType3))
        this.gameList4 = activeGames.filter(g => g.type.includes(this.curType3))
        // 最近发布
        this.gameListNew = activeGames
        .filter(g => g.date)
        .sort((a, b) => Date.parse(b.date) - Date.parse(a.date))
        // 最近更新
        this.gameListRecent = [...activeGames].sort((a, b) => Date.parse(b.update) - Date.parse(a.update))
      })
    },
    getStaticData() {
       var gameArr=JSON.parse(localStorage.getItem('gameList'))
       if(gameArr){
        const activeGames = JSON.parse(localStorage.getItem('gameList')).filter(g => g.status !== 0)
        this.gameList = activeGames.filter(g => g.type.includes(this.curType))
        this.gameList2 = activeGames.filter(g => g.type.includes(this.curType2) && !g.type.includes(this.curType)).sort((a, b) => Date.parse(b.update) - Date.parse(a.update))
        this.gameList3 = activeGames.filter(g => !g.type.includes(this.curType) && !g.type.includes(this.curType2) && !g.type.includes(this.curType3))
        this.gameList4 = activeGames.filter(g => g.type.includes(this.curType3))
        // 最近发布
        this.gameListNew = activeGames
        .filter(g => g.date)
        .sort((a, b) => Date.parse(b.date) - Date.parse(a.date))
        // 最近更新
        this.gameListRecent = [...activeGames].sort((a, b) => Date.parse(b.update) - Date.parse(a.update))
        }else{
          this.getData()
        }
    },
    getNavData() {
      const timeStamp = new Date().getTime()
      this.$http.get('static/data/home_nav_box.json' + '?' + timeStamp).then(game => {
        this.navLeftList = game.data[0].left.filter(item => item.status === 1)
        this.navRightList = game.data[1].right.filter(item => item.status === 1)
      })
    },
    checkDaysDifference(date) {
      const now = new Date();
      const otherDate = new Date(date); // 示例日期，根据需要替换
      const timeDifference = now.getTime() - otherDate.getTime();
      const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
      return daysDifference < 7; // 更新数据属性以供模板使用
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
